export const processDateRangeData = (rawData, config, params) => {
  const { responsePath, xAxisKey, extractValue, reverseValues, isAverage } = config;
  const { prev_start_date, prev_end_date, start_date, end_date } = params;

  const fullList = responsePath.split(".").reduce((obj, key) => obj?.[key], rawData) || [];

  const prevList = fullList.filter((item) => item[xAxisKey] >= prev_start_date && item[xAxisKey] <= prev_end_date);
  const curList = fullList.filter((item) => item[xAxisKey] >= start_date && item[xAxisKey] <= end_date);

  const prevY = prevList.map(extractValue).reverse();
  let curY = curList.map(extractValue);
  let curX = curList.map((item) => item[xAxisKey]);

  if (reverseValues) {
    curX = [...curX].reverse();
    curY = [...curY].reverse();
  }

  const validPrevY = prevY.filter((value) => value !== null && value !== undefined && !isNaN(value)).map(Number);
  const validCurY = curY.filter((value) => value !== null && value !== undefined && !isNaN(value)).map(Number);

  const prevNet = validPrevY.reduce((sum, value) => sum + value, 0);
  const curNet = validCurY.reduce((sum, value) => sum + value, 0);

  let curValue = curNet;
  let prevValue = prevNet;

  if (isAverage) {
    prevValue = validPrevY.length ? prevNet / validPrevY.length : 0;
    curValue = validCurY.length ? curNet / validCurY.length : 0;
  }

  const percentageChange = prevValue === 0
    ? (curValue > 0 ? 100 : 0)
    : ((curValue - prevValue) / prevValue) * 100;

  const formattedPercentageChange = percentageChange > 0
    ? (percentageChange === Infinity ? "↑" : `+${percentageChange.toFixed(1).replace(/\.0$/, "")}%`)
    : `${percentageChange.toFixed(1).replace(/\.0$/, "")}%`;

  const netValue = Number.isInteger(curValue) ? curValue : curValue.toFixed(2);

  return {
    xAxis: curX,
    yAxis: curY,
    netValue,
    percentageChange,
    formattedPercentageChange,
  };
};

export default processDateRangeData;
